<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editEmployerLeaveTypeCatNames_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="section-title">
      <mat-icon>business_center</mat-icon>
      <p class="grey1">{{ data.sysText.leaveCategories }}</p>
      <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.leaveCategories_customName_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="right">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    @for(customNameFormGroup of form.controls.leaveCategories.controls; track customNameFormGroup) {
      <div class="field-container">
        <div class="field">
          <app-input-field
            [hideIconSpace]="false"
            [label]="data.sysText.customName"
            [control]="customNameFormGroup.controls.customName">
          </app-input-field>
        </div>
        <div class="field">
          <app-input-field
            [hideIconSpace]="false"
            [label]="data.sysText.defaultName"
            [control]="customNameFormGroup.controls.name">
          </app-input-field>
        </div>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

